import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";
import "./index.css";
export class NavBarTab extends PureComponent {
  render() {
    const { className, children } = this.props;
    const cls = classNames({
      "weui-navbar": true,
      [className]: className
    });
    return (
      <div className={ cls }>
        { children }
      </div>
    );
  }
}
